import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {Container, Row, Col, Card, CardBlock, FormGroup, Label, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import {renderCheckbox} from "../forms/newcaso/Fields";

class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null,
            message: null,
            labs: [],
            legal: false
        };
    };
    componentDidMount(){
        axios.get(`/api/labs`).then(response => {
            this.setState({labs: response.data})
        }).catch(error => {
            this.setState({status: 'error', message: error})
            console.error(error)
        });

    }

    handleFormSubmit(values) {
        console.log(values);
        this.setState({status: 'loading'})
        axios.post(`/api/user/new`, values).then(response => {
            console.log(response)
            this.setState({status: 'success'})
        }).catch(error => {
            this.setState({status: 'error', message: error})
            console.error(error)
        });

    }

    renderSelect(field) {
        let options = this.state.labs || [];
        if(options.length === 1){
            return <input type="hidden" value={options[0].id} name={options[0].name} />
        }
        options = options.map(item => {
            return <option key={item.id} value={item.id}>{item.name}</option>;
        });
        options.unshift(<option key="_0" value="_0">Seleccione laboratorio</option>);
        return (
            <div className="form-group">
                <select
                    className="form-control"
                    {...field.input}
                >
                    {options}
                </select>
                {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
            </div>
        )
    }

    renderError(msg) {
        return (
            <div className="alert alert-danger" role="alert">
                {msg.response.data.message || "Ha ocurrido un error de conexión por favor intentelo de nuevo más tarde."}
            </div>
        )
    }

    renderInput(field) {
        return <div><InputGroup className="mb-3">
            <InputGroupAddon>
                <i className={`fa ${field.icon}`}></i>
            </InputGroupAddon>
            <input
                className={field.meta.touched && field.meta.error ? "form-control is-invalid" : "form-control"}
                type={field.type}
                placeholder={field.placeholder}
                disabled={field.disabled}
                {...field.input}
            />
        </InputGroup>
        </div>
    }
    renderCheckbox = (field) => {
        return(
            <div className="mb-3">
                <label className= "form-check-label">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={field.input.value}
                        disabled={field.disabled}
                        {...field.input} />
                     He leido y acepto los <a className="text-info" href="/legal" target="_blank">Terminos y condiciones</a> del servicio
                </label>
                {field.meta.touched && field.meta.error && <div className="text-danger">{field.meta.error}</div>}
            </div>
        )
    };

    renderContainer() {
        const {handleSubmit} = this.props;
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <Card className="mx-4">
                                <CardBlock className="p-4">
                                    {this.renderForm()}
                                </CardBlock>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
    renderForm() {
        const {handleSubmit} = this.props;
        return (
            <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                <h1>Registro de usuario</h1>
                <p className="text-muted">Solicitud de alta de cliente</p>
                {this.state.status === "error" && this.renderError(this.state.message)}
                <Field
                    name="num_colegiado"
                    type="input"
                    placeholder="Número de colegiado"
                    icon="fa-user-md"
                    component={this.renderInput}
                />
                <Field
                    name="nombre"
                    type="input"
                    placeholder="Nombre"
                    icon="fa-user"
                    component={this.renderInput}
                />
                <Field
                    name="apellidos"
                    type="input"
                    placeholder="Apellidos"
                    icon="fa-user"
                    component={this.renderInput}
                />
                <Field
                    name="email"
                    type="input"
                    placeholder="Email"
                    icon="fa-envelope"
                    component={this.renderInput}
                />
                <Field
                    name="phone"
                    type="input"
                    placeholder="Teléfono"
                    icon="fa-phone"
                    component={this.renderInput}
                />
                <Field
                    name="lab_id"
                    col="col-md-4"
                    onChange={(e) => {
                        if (e.target.value === "_1") {
                            this.toggle()
                        }
                    }}
                    component={this.renderSelect.bind(this)}
                />
                <Field
                    name="legal"
                    col="col-md-4"
                    onChange={(e)=>{
                        this.setState({legal: !this.state.legal})
                    }}
                    component={this.renderCheckbox.bind(this)}
                />
                <Button color="success" block>Enviar solicitud</Button>
            </form>
        )
    }

    renderLoading() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <div className="text-center"><i
                            className="text-muted fa-5x fa fa-spin fa-circle-o-notch"></i></div>
                    </Row>
                </Container>
            </div>
        )

    }

    renderSuccess() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <div className="text-center"><i className="text-success fa fa-5x fa-check-circle-o"></i>
                            <p className="lead">Su solicitud se ha enviado</p><span className="text-muted">En breve nos pondremos en contacto, gracias.</span>
                        </div>
                    </Row>
                </Container>
            </div>
        )
    }

    render() {
        return (
            <div>
                {{
                    null: (
                        this.renderContainer()
                    ),
                    'error': (
                        this.renderContainer()
                    ),
                    'loading': (
                        this.renderLoading()
                    ),
                    'success': (
                        this.renderSuccess()
                    )
                }[this.state.status]}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        initialValues: {
            lab_id: ownProps.lab || null
        },
        errorMessage: state.auth.error,

    };
}
const validate = (values) => {
    // apellidos
    // email
    // lab_id
    // nombre
    // num_colegiado
    // phone

    const msg_req = "Campo requerido";
    let errors = {};
    if (!values.nombre) {
        errors.nombre = msg_req;
    }
    if (!values.apellidos) {
        errors.apellidos = msg_req;
    }
    if (values.phone && !/^(([\+]?[ 0-9]{1,6}([ \.\-])?)?([\(]{1}[ +0-9]{2,6}[\)])?([ 0-9A-Z\.\-]{1,32})([0-9]+))|((e|x|ex|ext|extension)(\.|\:)?([ ]{1})?[0-9]+)$/i.test(values.phone)) {
        errors.phone = msg_req;
    }
    if (!values.num_colegiado || !/^\d+$/i.test(values.num_colegiado)) {
        errors.num_colegiado = msg_req;
    }
    if (!values.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = msg_req;
    }
    if (!values.lab_id || values.lab_id === "_0") {
        errors.lab_id = msg_req;
    }
    console.log(values.legal)
    if (!values.legal) {
        errors.legal = "Debe aceptar las condiciones del servicio";
    }
    return errors;
}
Signup = reduxForm({
    form: 'signup',
    validate: validate
})(Signup);
export default Signup = connect(mapStateToProps, null)(Signup);


// WEBPACK FOOTER //
// ./resources/assets/js/components/auth/signup.jsx